var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.name.toUpperCase())+" "),_c('span',[_vm._v("FP: "+_vm._s(_vm.cost))])]),_c('span',[_vm._v(_vm._s(_vm.stripDescription(_vm.description)))])])}
var staticRenderFns = []

export { render, staticRenderFns }